'use client'

import dynamic from 'next/dynamic'
import { Box, Grid, Typography } from '@mui/material'

// Types
import type { SolutionStepProps } from '@/types/components/molecules/solution'

// Components
const RevealAtom = dynamic(() => import('@/components/atoms/animation/reveal'))
const FramedImageAtom = dynamic(() => import('@/components/atoms/image/framed'))

// One step of "how it works": labeled text on one side, photo on the other
const SolutionStepMolecule = (props: SolutionStepProps) => {
	// Props
	const { label, title, description, image, reversed } = props

	return (
		<Grid container spacing={{ xs: 4, md: 10 }} sx={{ alignItems: 'center', flexDirection: { xs: 'column-reverse', md: reversed ? 'row-reverse' : 'row' } }}>
			<Grid size={{ xs: 12, md: 5 }}>
				<RevealAtom>
					<Typography sx={{ fontSize: 14, fontWeight: 500, color: 'primary.dark' }}>{label}</Typography>

					<Typography component="h3" sx={{ mt: 1.5, fontSize: { xs: 20, md: 24 }, fontWeight: 700, lineHeight: 1.45 }}>
						{title}
					</Typography>

					<Typography sx={{ mt: 2, fontSize: { xs: 16, md: 17 }, lineHeight: 2, color: 'text.secondary' }}>{description}</Typography>
				</RevealAtom>
			</Grid>

			<Grid size={{ xs: 12, md: 7 }} sx={{ width: 1 }}>
				<RevealAtom delay={0.15} offset={40}>
					<Box sx={{ position: 'relative' }}>
						{/* Soft brand glow behind the photo */}
						<Box
							sx={{
								position: 'absolute',
								inset: '8% -4% -6% 6%',
								borderRadius: 8,
								background: t => `linear-gradient(135deg, ${t.palette.primary.light}, transparent 70%)`,
								filter: 'blur(28px)',
								opacity: 0.7
							}}
						/>

						<FramedImageAtom src={image} alt={title} height={{ xs: 260, md: 420 }} radius={6} sizes="(max-width: 900px) 100vw, 560px" />
					</Box>
				</RevealAtom>
			</Grid>
		</Grid>
	)
}

export default SolutionStepMolecule
